export default class Motivo {

  constructor(
    IdMotivo = null,
    Descricao = '',
    Status = 'A',
  ) {
    this.IdMotivo = IdMotivo;
    this.Descricao = Descricao;
    this.Status = Status;
  }
  
}